import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { ActivatedRoute, Router } from '@angular/router';
import { GetUserInformationService } from '../services/get-user-information.service';
import { ValidateUserPasswordService } from '../services/validate-user-password.service';
import { ChangePasswordService } from '../services/change-password.service';
import { CommonUtil } from '../../core/Utils/common-util';
import { ToastMessageService } from '../../core/shared-service/toast-message.service';
import { PasswordPolicy } from '../helpers/password.policy.validator';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import {IDataToSendForPasswordValidation , IDataToSendForChangePassword} from '../services/pre-login.model';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.css'],
})
export class UpdatePasswordComponent implements OnInit {
  newpasswordPreviewFlag = false;
  confirmpasswordPreviewFlag = false;
  updatePasswordForm: FormGroup;
  rootScopeData: RootScopeDeclare;
  newpasswordFlag = false;
  confirmpasswordFlag = false;
  newpassword: string;
  confirmpassword: string;
  passwordMismatch = false;
  updatePasswordUserToken: string;
  userEmail: string;
  userId: string;
  showModal = false;

  dataToSendForPasswordValidation: IDataToSendForPasswordValidation ;
  dataToSendForChangePassword: IDataToSendForChangePassword;

  isCurrentMatchingSavedPwd: boolean;
  userIdPasswordMatching = false;

  // for mobile tooltip
  @ViewChild('tt1', { static: false }) mytooltip1: NgbTooltip;
  @ViewChild('tt2', { static: false }) mytooltip2: NgbTooltip;

  constructor(
    private fb: FormBuilder,
    private rootScopeService: RootScopeService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private getUserInfo: GetUserInformationService,
    private validateUserInfo: ValidateUserPasswordService,
    private changePassword: ChangePasswordService,
    public commonUtil: CommonUtil,
    private toastMessageService: ToastMessageService,
    private loader: HaloLoaderService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService
  ) {
    this.getRootScopeData();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => (this.rootScopeData = rootScopeData));
  }
  ngOnInit() {
    this.rootScopeData.pageName = 'UpdatePassword';

    this.updatePasswordForm = this.fb.group(
      {
        newpassword: ['', Validators.required],
        confirmpassword: ['', Validators.required],
      },
      {
        validator: [PasswordPolicy('newpassword'), PasswordPolicy('confirmpassword')],
      }
    );
    this.updatePasswordUserToken = this.activatedRoute.snapshot.queryParams.token;
    if (this.updatePasswordUserToken) {
      this.getUserDetails(this.updatePasswordUserToken);
    }
  }
  getUserDetails(token: string) {
    this.getUserInfo.getUserInformations(token).subscribe(
      data => {
        this.userEmail = data.emailAddress;
        this.userId = data.nickName;
      },
      error => {
        console.error('API failed.');
      }
    );
  }
  get updatePasswordvalidator() {
    return this.updatePasswordForm.controls;
  }

  newPasswordRules(event: { target: HTMLInputElement; }) {
    this.newpassword = event.target.value;
    this.newpasswordFlag = true;
    if (this.updatePasswordForm.dirty && this.updatePasswordForm.valid) {
      if (this.newpassword != this.confirmpassword) {
        this.passwordMismatch = true;
      } else {
        this.passwordMismatch = false;
      }
    }
  }
  confirmPasswordRules(event: { target: HTMLInputElement; }) {
    this.confirmpassword = event.target.value;
    this.confirmpasswordFlag = true;
    if (this.updatePasswordForm.dirty && this.updatePasswordForm.valid) {
      if (this.newpassword != this.confirmpassword) {
        this.passwordMismatch = true;
      } else {
        this.passwordMismatch = false;
      }
    }
  }

  submitUpdatedPassword() {
    if (this.updatePasswordForm.dirty && this.updatePasswordForm.valid) {
      this.validatePassword();
    }
  }

  validatePassword() {
    this.dataToSendForPasswordValidation ={emailAddress:this.userEmail,password:btoa(this.newpassword)};
    this.validateUserInfo.validateUserInformation(this.dataToSendForPasswordValidation).subscribe(
      data => {
        this.isCurrentMatchingSavedPwd = data.isPasswordValid == 'true' ? true : false;
        if (
          (this.userId != undefined && this.userId.toLowerCase() == this.newpassword.toLocaleLowerCase()) ||
          this.userEmail.toLowerCase() == this.newpassword.toLocaleLowerCase()
        ) {
          this.userIdPasswordMatching = true;
        } else {
          this.userIdPasswordMatching = false;
        }
        if (
          this.isCurrentMatchingSavedPwd != undefined &&
          this.userIdPasswordMatching != undefined &&
          this.isCurrentMatchingSavedPwd == false &&
          this.userIdPasswordMatching == false
        ) {
          this.saveNewPassword();
        }
      },
      error => {
        console.error('API failed.');
      }
    );
  }



  stopTracking(e: Event) {
    e.stopPropagation();
    e.preventDefault();

    if (this.rootScopeData.isRTL) {
      if (this.mytooltip2.isOpen()) {
        this.mytooltip2.close();
      } else {
        this.mytooltip2.open();
      }
    } else {
      if (this.mytooltip1.isOpen()) {
        this.mytooltip1.close();
      } else {
        this.mytooltip1.open();
      }
    }
  }

  saveNewPassword() {
    this.loader.startProcess();
    this._amplitudeAnalytics.logEvent({elementName: 'Submit', action: "Click"});
    this.dataToSendForChangePassword={token: this.updatePasswordUserToken, encodedPassword : btoa(this.newpassword)};
    //this.dataToSendForChangePassword.encodedPassword = btoa(this.newpassword);
    this.changePassword.changeToNewPassword(this.dataToSendForChangePassword).subscribe(
      data => {
        this.loader.endProcess();
        this.toastMessageService.emitChange(this.commonUtil.translateText('UPDATE.PASSWORD.SUCCESS.TAOST.MESSAGE'));
        this.router.navigate(['/login']);
      },
      error => {
        console.error('API failed.');
        this.loader.endProcess();
      }
    );
  }

  cancelUpdatePassword() {
    if (this.updatePasswordForm.dirty) {
      this.openModal();
      return;
    }
    this.router.navigate(['/login']);
  }
  openModal(): void {
    this.showModal = true;
  }

  onPositiveConfirmation(): void {
    this.closeModal();
    this.router.navigate(['/login']);
  }

  closeModal(): void {
    this.showModal = false;
  }
}
